import React from "react";

/**
 * Invoerveld in de huisstijl.
 *
 * Eén afwijking van het prototype uit het designsysteem: dit veld geeft zijn ref door.
 * De formulieren in de app draaien op react-hook-form, en dat registreert een veld via
 * een ref. Zonder doorgeven blijft het veld leeg voor de validatie — het formulier lijkt
 * te werken en verstuurt niets. De vormgeving is verder ongewijzigd.
 */
export const Input = React.forwardRef(function Input({ invalid, mobiel = true, style, ...rest }, ref) {
  const [focus, setFocus] = React.useState(false);
  return (
    <input
      ref={ref}
      onFocus={(e) => { setFocus(true); rest.onFocus?.(e); }}
      onBlur={(e) => { setFocus(false); rest.onBlur?.(e); }}
      style={{
        width: "100%", minHeight: mobiel ? "var(--veld-hoogte)" : "var(--veld-hoogte-desktop)",
        // 16px is geen smaak maar noodzaak: kleiner en iOS Safari zoomt in bij focus.
        fontSize: mobiel ? "var(--fs-invoer-mobiel)" : "var(--fs-body)",
        fontFamily: "var(--font-tekst)", color: "var(--text-strong)",
        padding: "var(--ruimte-4) var(--ruimte-5)", borderRadius: "var(--radius)",
        background: invalid ? "var(--alarm-zacht)" : "var(--wit)",
        border: "1px solid " + (invalid ? "var(--alarm-rand)" : focus ? "var(--actie)" : "var(--border-subtle)"),
        boxShadow: focus ? "var(--schaduw-focus)" : "var(--schaduw-1)",
        outline: "none", transition: "var(--overgang-kleur)", ...style,
      }}
      {...rest}
    />
  );
});
